<template>
    <div class="mx-auto my-16 max-w-md lg:max-w-xl px-6 text-center">
        <div v-if="$slots.icon" class="mb-6 flex justify-center">
            <div
                class="flex h-32 w-32 items-center justify-center rounded-full bg-taupe-100 text-taupe-400"
            >
                <slot name="icon" />
            </div>
        </div>
        <h3 class="text-3xl font-medium text-taupe-700">{{ title }}</h3>
        <p class="mt-3 text-lg text-taupe-500">{{ description }}</p>
        <div
            class="mt-6 flex flex-col items-center gap-3 sm:flex-row sm:justify-center"
        >
            <zen-button
                v-if="primaryAction"
                variant="primary"
                :to="primaryAction.to"
                @click="onPrimaryActionClick"
            >
                {{ primaryAction.label }}
            </zen-button>
            <a
                v-if="docsLink"
                :href="docsLink"
                target="_blank"
                rel="noopener noreferrer"
                class="text-sm font-medium text-sky-600 hover:text-sky-700 hover:underline"
            >
                View docs &rarr;
            </a>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    description: {
        type: String,
        required: true,
    },
    primaryAction: {
        type: Object,
        default: null,
    },
    docsLink: {
        type: String,
        default: null,
    },
})

// A link-mode primaryAction (`to` set) navigates on click; only invoke the
// handler when there's no navigation to avoid firing both simultaneously.
function onPrimaryActionClick(event) {
    if (!props.primaryAction.to) {
        props.primaryAction.handler?.(event)
    }
}
</script>
